import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'
import { ServiceLocationCardDetail } from '@user/components/Services/ServiceLocationCardDetail'
import { ENTITY_TYPES } from '@sales-center/common'
import { selectAllServiceFrequencies } from '@user/store/serviceFrequency/slice'
import { selectAllServiceLocations } from '@user/store/entityLocations'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface Props {
  services: ILeadOppProduct[]
  entityId: number
  entityType: ENTITY_TYPES
}

export const ServiceList: FC<Props> = (props) => {
  const { services, entityType } = props

  const serviceLocations = useSelector(selectAllServiceLocations)
  const serviceFrequencies = useSelector(selectAllServiceFrequencies)

  const filteredServiceLocations = useMemo(
    () =>
      serviceLocations.filter((s) =>
        services.find((sv) => sv.serviceLocationId == s.id.toString()),
      ),
    [services, serviceLocations],
  )

  const theme = useTheme()

  return (
    <>
      <Box sx={{ marginTop: theme.spacing(4.8) }}>
        <Typography variant="h7" sx={{ fontWeight: '600' }}>
          Services Added
        </Typography>
        <Box
          sx={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(2.8) }}
        >
          <Typography variant="body2">
            These services will appear on the agreement and be used to calculate
            closed/won or closed/lost value.
          </Typography>
        </Box>
      </Box>
      {filteredServiceLocations.map((s) => (
        <ServiceLocationCardDetail
          disableGrayBg
          location={s}
          key={s.id}
          entityType={entityType}
          serviceFrequencies={serviceFrequencies}
          minimumServicesCount={1}
          localMode={false}
          disabled
          readOnly
          loading={false}
          defaultExpanded
          variant="old"
        />
      ))}
    </>
  )
}

ServiceList.displayName = 'ServiceList'
